import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from "@/i18n";

Vue.use(VueRouter)

// Importaciones dinámicas para la carga perezosa de componentes
const DefaultLayout = () => import('@/views/base/DefaultLayout.vue')
const SolWizard = () => import('@/views/SolicitudWizard.vue')
// const ActWizard = () => import('@/views/ActivarWizard.vue')
const Verificar = () => import('@/views/VerificarV.vue')
const inicio = () => import("@/views/Inicio.vue");
const fecha = () => import("@/views/fechas.vue");

const routes = [
  {
    path: '/',
    redirect: `/${i18n.locale}/inicio`
  },
  {
    path: '/:lang',
    component: DefaultLayout,
    redirect: '/',
    children: [
      {
        path: 'inicio',
        name: 'inicio',
        component: inicio,
      },
      {
        path: 'solicitar/visa',
        name: 'solicitar',
        component: SolWizard,
      },
      // {
      //   path: 'activar/visa',
      //   name: 'activar',
      //   component: ActWizard
      // },
      {
        path: 'verificar/visa',
        name: 'verificar',
        component: Verificar
      },
      {
        path: 'fecha/visa',
        name: 'fecha',
        component: fecha,
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const lang = to.params.lang || i18n.locale;
  if (to.path !== from.path) {
    i18n.locale = lang;
    next();
  }
})

export default router